import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class ReportStudioPageDesignOption extends BaseModel {
  /**
   * @type {string}
   */
  background_color;

  /**
   * @type {string}
   */
  opacity;

  constructor(model = {}) {
    super();

    // eslint-disable-next-line tap/no-raw-text-js
    this.background_color = model.background_color ?? '#ffffff';
    this.opacity = model.opacity ?? 1;
  }
}
